import { render } from "./SettingsOrganisationDialog.vue?vue&type=template&id=48b8fb5e"
import script from "./SettingsOrganisationDialog.vue?vue&type=script&lang=js"
export * from "./SettingsOrganisationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__